import extractExportTypes from '@enums/extract-export-types';

export function useCompoundExtract() {
  // We need to have the translation method in the signature otherwise we get an error
  // when trying to use the useInternalization composable
  const getExtractTypeTranslation = ({ t, type, subType }) => {
    const typeTranslation = t(`compoundExtractsPage.${type}`);
    const subTypeTranslation = t(`compoundExtractsPage.${subType}`);
    if (!subType) return typeTranslation;
    return subTypeTranslation;
  };

  const formatExtractType = extract => getExtractTypeTranslation(extract).toUpperCase();

  const isSpaceTest = subType => subType === extractExportTypes.extractExportSubTypes.spaceTest;

  return {
    getExtractTypeTranslation,
    formatExtractType,
    isSpaceTest,
  };
}
